/* Single EventSource for platform directory SSE — mounted once at app shell so
 * /browse and other routes receive customer_directory_updated without visiting /shops.
 *
 * Production (Railway / reverse-proxy) expectations — see also
 * rpapp-customer/docs/ENGINEERING/MANUAL_DIRECTORY_LIVE_SYNC.md:
 * - Proxy idle timeouts may drop SSE; 30s health-check + capped reconnect (3s→30s) recover.
 * - While disconnected, CustomerDirectoryGlobalSync polls/refreshes on tab return (5s cooldown).
 * - HTTP 429 storm latch pauses reconnect until Retry-After clears (no reconnect stampede). */

import { createContext, useContext, type ReactNode } from 'react';
import { usePublicDirectorySSE } from './usePublicDirectorySSE.js';

const PublicDirectorySseContext = createContext(false);

export function PublicDirectorySseProvider({
  children,
}: {
  readonly children: ReactNode;
}): JSX.Element {
  const isConnected = usePublicDirectorySSE();
  return (
    <PublicDirectorySseContext.Provider value={isConnected}>
      {children}
    </PublicDirectorySseContext.Provider>
  );
}

/** Shared SSE connection state — do not call usePublicDirectorySSE outside the provider. */
export function usePublicDirectorySseConnected(): boolean {
  return useContext(PublicDirectorySseContext);
}
